import { render, staticRenderFns } from "./ProblemListTemplate.vue?vue&type=template&id=196eda68&"
import script from "./ProblemListTemplate.vue?vue&type=script&lang=js&"
export * from "./ProblemListTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports